import React, { useState, useEffect } from 'react';
import { Calendar, Video, CheckCircle } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom';

export default function MeetingsAdminPage() {
  const { api } = useAuth();
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api('get', '/api/admin/meetings').then(r => setMeetings(r.data.meetings || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-4xl">
      <h1 className="text-2xl font-bold text-white mb-6">Kick-off Meetings</h1>
      {loading ? (
        <div className="flex justify-center py-12"><div className="w-8 h-8 border-2 border-[#D4A017] border-t-transparent rounded-full animate-spin" /></div>
      ) : meetings.length === 0 ? (
        <div className="bg-[#0f172a] rounded-2xl border border-white/5 p-12 text-center">
          <Calendar className="w-12 h-12 text-[#475569] mx-auto mb-4" />
          <p className="text-[#64748b]">Geen meetings gepland</p>
        </div>
      ) : (
        <div className="space-y-3">
          {meetings.map(m => (
            <div key={m.id} className="bg-[#0f172a] rounded-2xl border border-white/5 p-5 flex items-center gap-5">
              <div className="w-14 h-14 bg-[#D4A017]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <Calendar className="w-7 h-7 text-[#D4A017]" />
              </div>
              <div className="flex-1">
                <Link to={`/admin/clients/${m.company_id}`} className="text-white font-bold hover:text-[#D4A017] transition-colors">{m.company_name}</Link>
                <p className="text-[#64748b] text-sm">{m.date} om {m.time}</p>
              </div>
              <a href={m.meeting_link} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-blue-500/20 text-blue-400 px-4 py-2 rounded-lg text-sm hover:bg-blue-500/30 transition-all">
                <Video size={14} /> Meeting openen
              </a>
              <span className="bg-green-500/20 text-green-400 text-xs px-2 py-1 rounded-full">Ingepland</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
